import PropTypes from 'prop-types';
import { Component } from 'react';
import type { MouseEvent } from 'react';

import utils from '../../utils';

interface IModalSlidePaneProps {
  onClose?: (e: MouseEvent<{}>) => void;
  onShow?: Function;
  show?: boolean;
  width?: number;
}

interface IModalDisplayLicenseState {
  showing?: boolean;
  displaying?: boolean;
}

class ModalSlidePane extends Component<IModalSlidePaneProps, IModalDisplayLicenseState> {
  static propTypes = {
    onClose: PropTypes.func,
    onShow: PropTypes.func,
    show: PropTypes.bool,
    width: PropTypes.number,
  };
  constructor(props) {
    super(props);
    this.state = {
      // Note: default to false otherwise we get a circular dep
      showing: false,
      displaying: false,
    };
  }
  componentDidMount() {
    this._updateDisplayState(this.props, true);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this._updateDisplayState(nextProps);
  }
  _updateDisplayState = (props, _) => {
    // we need to maintain showing state for in/out transitions

    if (this.state.showing && !props.show) {
      this.setState({ showing: false });
      setTimeout(() => {
        this.setState({ displaying: false });
      }, 600);
    } else if (!this.state.showing && props.show) {
      this.setState({ displaying: true });
      utils.defer(() => {
        if (!this.state.showing) {
          (this.props.onShow || (() => {}))();
          this.setState({ showing: true });
        }
      });
    }
  };
  render() {
    var width = this.props.width || 50;
    return this.state.displaying ? (
      <div className={'modal-view-dependency ' + (this.state.showing ? 'show' : '')}>
        <div className="modal-view-dependency-dialog" style={{ width: width + '%', minWidth: '400px' }}>
          {this.props.children}
        </div>
        <div
          className="modal-view-dependency-gutter"
          style={{ width: 100 - width + '%' }}
          onClick={this.props.onClose || (() => {})}
        />
        <div className="modal-view-dependency-highlight" />
      </div>
    ) : (
      <span />
    );
  }
}

export default ModalSlidePane;
